import React, { useMemo } from "react"

/**
 * Compact donut for Members by City header (40×40 Figma).
 * City Detail spellbook uses size={120} strokeWidth={22}.
 */
const MembersByCityDonut = ({
  segments = [],
  otherPercent = 0,
  size = 40,
  strokeWidth,
}) => {
  const stroke = strokeWidth ?? Math.max(6, Math.round(size * 0.2))
  const radius = (size - stroke) / 2
  const circumference = 2 * Math.PI * radius

  const arcs = useMemo(() => {
    const items = [
      ...segments.map(s => ({ color: s.color, percent: s.percent })),
      { color: "#d4d4d4", percent: otherPercent },
    ]
    let offset = 0
    return items.map((item, index) => {
      const length = (item.percent / 100) * circumference
      const arc = {
        key: `${item.color}-${index}`,
        color: item.color,
        dasharray: `${length} ${circumference - length}`,
        dashoffset: -offset,
      }
      offset += length
      return arc
    })
  }, [circumference, otherPercent, segments])

  return (
    <svg
      className="admin-dashboard__donut"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="#f0f0f0"
        strokeWidth={stroke}
      />
      {arcs.map(arc => (
        <circle
          key={arc.key}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={arc.color}
          strokeWidth={stroke}
          strokeDasharray={arc.dasharray}
          strokeDashoffset={arc.dashoffset}
          strokeLinecap="butt"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      ))}
    </svg>
  )
}

export default MembersByCityDonut
